import alt from 'alt'
import Immutable from 'immutable'
import { createStore, bind } from 'alt-utils/lib/decorators'
import { ExtendedUserActions } from 'actions'
import { UserUtils, ApiUtils } from 'utils'

@createStore(alt)
export default class ExtendedUserStore {
  constructor() {
    this.state = {
      shopifyUserFetchFailed: false
    }
    this.bindActions(ExtendedUserActions)
  }

  static displayName = 'ExtendedUserStore'

  setShopifyUserFetchFailed(shopifyUserFetchFailed) {
    this.setState({ shopifyUserFetchFailed })
  }
}



// WEBPACK FOOTER //
// ./app/stores/ExtendedUserStore.js